import { SvgIconType } from './svg.interface';

const PreviewOrder: SvgIconType = ({
  width = 16,
  height = 16,
  className = '',
  color = 'white'
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.61394 0.0171281C9.37487 -0.0468473 9.12982 0.0736297 9.03029 0.291209L7.03407 7.74118C6.89113 8.27465 7.20772 8.82298 7.74118 8.96593C8.27465 9.10887 8.82298 8.79228 8.96593 8.25882L9.57117 6H9.56788L10.9326 0.886638C11.004 0.62042 10.8458 0.34678 10.5793 0.275447L9.61394 0.0171281Z"
      fill={color}
    />
    <path
      d="M5.10222 7.22354L5.43007 6H1C0.447715 6 0 6.44772 0 7C0 7.55228 0.447715 8 1 8L1.90116 15.1104C1.95743 15.6169 2.38549 16 2.89504 16H13.105C13.6145 16 14.0426 15.6169 14.0988 15.1104L15 8C15.5523 8 16 7.55228 16 7C16 6.44772 15.5523 6 15 6H11.6417L10.8978 8.77646C10.469 10.3769 8.82394 11.3266 7.22354 10.8978C5.62314 10.469 4.6734 8.82394 5.10222 7.22354Z"
      fill={color}
    />
  </svg>
);

export default PreviewOrder;
